import { RbcCircleRec } from '@calm/evexia-web-sdk';
import { isRecommended } from '@rhg/utils/recommendations';
import { useCircleRecommendations } from '../use-recommendations';

interface UseProgramAndWorkflowIdsProps {
    circleId: number;
    showAll?: boolean;
}
interface UseProgramAndWorkflowIdsResponse {
    isFetched: boolean;
    isPending: boolean;
    shownProgramRecommendations?: RbcCircleRec[];
    workflowDefnIds?: string[];
}

export function useProgramAndWorkflowIds({
    circleId,
    showAll,
}: UseProgramAndWorkflowIdsProps): UseProgramAndWorkflowIdsResponse {
    const { programs, isFetched, isPending } =
        useCircleRecommendations(circleId);

    if (!isFetched || isPending) {
        return {
            isPending,
            isFetched: false,
            shownProgramRecommendations: undefined,
            workflowDefnIds: undefined,
        };
    }

    const shownProgramRecommendations = showAll
        ? programs
        : programs?.filter(isRecommended) ?? [];

    const workflowDefnIds = shownProgramRecommendations?.reduce<string[]>(
        (ids, programRec) =>
            programRec.additionalData?.workflowId
                ? [...ids, programRec.additionalData?.workflowId]
                : ids,
        []
    );

    return {
        isPending,
        isFetched,
        workflowDefnIds,
        shownProgramRecommendations,
    };
}
